import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { delay } from 'rxjs/operators';
import { Subscription } from 'rxjs';
import { LocalStoreService } from "../../shared/services/local-store.service";

@Injectable()
export class PaymentsService {
  private baseUrl: string = '';
  private collection: string = 'payments';
  public owner: string;
  public account: string;
  public ownerName: string;

  items: any[];

  constructor(private http: HttpClient, public local: LocalStoreService) {
    //this.local.setItem('url.base','https://192.168.1.30:8443/api/v1');
    this.baseUrl=this.local.getItem('url.base')+'/'+this.collection; 

    this.owner    = this.local.getItem('user.id');  
    this.account  = this.local.getItem('user.account'); //this.local.getItem('user.account'); 
    this.ownerName   = this.local.getItem('user.fullname');  
    

    let itemSub: Subscription;
  }



  // get by id
  findById(id): Observable<any> {
    return this.http.get(this.baseUrl+'/id/'+id);
  }

  // get by order
  findByOrder(id): Observable<any> {
    return this.http.get(this.baseUrl+'/order/'+id);
  }
  
  // get by owner
  findByOwner(): Observable<any> {
    return this.http.get(this.baseUrl+'/owner/'+this.owner);
  }

  // get by account
  findByAccount(): Observable<any> {
    return this.http.get(this.baseUrl+'/account/'+this.account);
  }

  // get by buyer for suppliers 
  findByBuyer(): Observable<any> {
    console.log (this.baseUrl+'/buyer/'+this.account);
    return this.http.get(this.baseUrl+'/buyer/'+this.account);
  }
   


 
  // get by account and Report
  findByAccountAndIdReport(id): Observable<any> {
    return this.http.get(this.baseUrl+'/account/'+this.account+'/report/'+id);
  }  
  // get by company
  findByCompany(id): Observable<any> {
    return this.http.get(this.baseUrl+'/company/'+id);
  }


  // get by Keywords
  findByKeywords(id): Observable<any> {
    return this.http.get(this.baseUrl+'/search/'+this.account+'/'+id);
  }


  // create customer payment 
  create(item){
    item.recordId = Math.round(Math.random() * 10000000000).toString();
    item.owner = this.owner;
    item.account = this.account;
    item.ownerName = this.ownerName;

    return this.http.post(this.baseUrl, item);
  }

  // create supplier payment
  createSupplier(item){
    item.recordId = Math.round(Math.random() * 10000000000).toString();
    item.owner = this.owner;
    item.account = this.account;
    item.ownerName = this.ownerName;

    return this.http.post(this.baseUrl+"/supplier", item);
  }


    // create customer payment 
  createPaymentMultiple(item){
    item.recordId = Math.round(Math.random() * 10000000000).toString();
    item.owner = this.owner;
    item.account = this.account;
    item.ownerName = this.ownerName;

    return this.http.post(this.baseUrl+"/multiple", item);
  }






  update(item){
    this.http.put(this.baseUrl, item).subscribe(res => console.log(res )); 
    this.items=[];
    this.items.unshift(item);
    return of(this.items.slice()).pipe(delay(100));
  }

   // delete demande
   delete(row, demandes) {
    let id = row.id;
    this.items = demandes;

    let i = this.items.indexOf(row);
    let index = 0;
    for (let item of this.items) {
      if (item.id==id){
        i=index;
      } 
      index++;
    }

    this.baseUrl = this.local.getItem('url.base')+'/pricing/remove'; 
    this.http.delete(this.baseUrl+'/'+id).subscribe(res => console.log(res ));
    this.items.splice(i, 1);
    return of(this.items.slice()).pipe(delay(100));
  } 


}
